document.querySelectorAll('.yoria-blog').forEach((section) => {
  if (section.dataset.guideTabsReady === 'true') return;

  const tabs = [...section.querySelectorAll('[data-guide-tab]')];
  const panels = [...section.querySelectorAll('[data-guide-panel]')];
  const glossarySection = document.querySelector('.yoria-guide-glossary')?.closest('.shopify-section');

  if (tabs.length !== 2 || panels.length !== 2) return;

  const setActiveTab = (name, updateHash = true) => {
    const activeTab = tabs.find((tab) => tab.dataset.guideTab === name) || tabs[0];

    tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach((panel) => {
      panel.hidden = panel.dataset.guidePanel !== activeTab.dataset.guideTab;
    });

    if (glossarySection) glossarySection.hidden = activeTab.dataset.guideTab === 'support';

    if (updateHash) {
      const hash = activeTab.dataset.guideTab === 'support' ? '#support' : '#guides';
      history.replaceState(null, '', `${location.pathname}${location.search}${hash}`);
    }
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => setActiveTab(tab.dataset.guideTab));
    tab.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1);
      nextIndex = (nextIndex + tabs.length) % tabs.length;
      tabs[nextIndex].focus();
      setActiveTab(tabs[nextIndex].dataset.guideTab);
    });
  });

  section.classList.add('is-enhanced');
  const hasManualQuery = new URL(window.location.href).searchParams.has('manual_q');
  setActiveTab(location.hash === '#support' || hasManualQuery ? 'support' : 'guides', false);
  section.dataset.guideTabsReady = 'true';
});
